import { render } from "./Consultation.vue?vue&type=template&id=6e6c0750"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__